import React from 'react';
import FindItActivityProgress from '@monorepo/shared/src/components/activities/FindItActivityProgress';
import HintButton from '@monorepo/shared/src/components/modules/Paging/components/HintButton';
import makeStyles from '@mui/styles/makeStyles';
import { ActivityTypes } from '@monorepo/shared/src/providers/GameProvider/types';

const FindTheLetterFooter: React.FC = () => {
  const classes = useStyles();
  return (
    <>
      <FindItActivityProgress activityType={ActivityTypes.FIND_THE_LETTER} />
      <div className={classes.hintWrapper}>
        <HintButton />
      </div>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  hintWrapper: {
    position: 'absolute',
    right: theme.constants.app.paddingX,
  },
}));

export default FindTheLetterFooter;
